import { useEffect, useState } from "react"
import { useParams } from "react-router-dom";
import { aepsTransctionAll, allWalletReportExcel, walletsReportFilter } from "../../api/login/Login"
import Breadcrumbs from "../../common/breadcrumb/Breadcrumbs"
import WalletsReportsList from "./walletsReportsList/WalletsReportsList"
import WalletsReportsSearch from "./walletsReportsSearch/WalletsReportsSearch"
import * as XLSX from 'xlsx';
import { message } from "antd";



function WalletsReport() {
    const breadCrumbsTitle = {
        id: "1",
        title_1: "Reports",
        title_2: "Wallets Report",
    }
    const params = useParams();
    const userId = params?.id
    console.log("userId ",userId )
    const [loading, setLoading] = useState(false);
    const [excelLoader , setExcelLoader] = useState(false)
    const [count, setCount] = useState(10)
    const [page, setPage] = useState(0)
    const [data, setSata] = useState(null)
    const [submitButton , setSubmitButton] = useState(false)
    const [totalCount, setTotalCount] = useState()
    const [initialValues, setInitialValues] = useState({
        min_amt: '',
        max_amt: "",
        start_date: '',
        end_date: '',
        type: '',
        trans_type: "",
        userId: userId  , 
    });


    const submitForm = async () => {

        setLoading(true)
        try {
            // const formData = {
            //     ...(values || initialValues),
            //     userId: userId,  
            // };
            const res = await walletsReportFilter(page, count,userId, initialValues);
            setSata(res?.data?.wallet);
            setTotalCount(res?.data?.total)
            // console.log(res?.data?.total);
            setLoading(false)
        } catch (error) {

        }
    };

    const onChangeVal = (e) => {
        // submitForm(e - 1)
        setPage(e - 1)
    };

    useEffect(() => {
        submitForm()
    }, [page , submitButton])
    
    

    const downloadExcel = async () => {
        try {
          setExcelLoader(true);
          const res = await allWalletReportExcel({
            ...initialValues,
          });
    
          if (res && res?.data?.wallet && res?.data?.wallet.length > 0) {
            const dataForExcel = res.data.wallet.map((item, i) => ({
              "Sr. No": i + 1,
              "Date / Time": item?.createdAt,
              "Order ID": item?.order_id,
              "Transaction ID":  item?.txn_id || "",
              "Opening Balance": item?.o_bal,
              "Amount": item?.amount,
              "Closing Balance": item?.c_bal,
              "Type": item?.type,
              'Transaction Type': item?.trans_type || "",
              "Message": item?.message || "",
              
             
              
              
              
              
              
             
              
             
             
             
          
              
            }));
    
            const ws = XLSX.utils.json_to_sheet(dataForExcel);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "AEPS Cash Report");
            XLSX.writeFile(wb, `Wallet_Report_${new Date().toLocaleDateString()}.xlsx`);
          } else {
            message.error('No data available to export!');
          }
        } catch (error) {
          console.error("Error downloading Excel:", error);
          message.error('Failed to download Excel. Please try again.');
        } finally {
          setExcelLoader(false);
        }
      };

    return (
        <>
            <Breadcrumbs breadCrumbsTitle={breadCrumbsTitle} />
            <WalletsReportsSearch  setPage={setPage} setSubmitButton={setSubmitButton} setInitialValues={setInitialValues} initialValues={initialValues} submitForm={submitForm} />
            <WalletsReportsList page={page} downloadExcel={downloadExcel} excelLoader={excelLoader} data={data} totalCount={totalCount} onChangeVal={onChangeVal} loading={loading} />
        </>
    )
}
export default WalletsReport